import { CircularProgress, SxProps } from "@mui/material";

const Spinner = ({ sx }: { sx?: SxProps }) => (
  <CircularProgress size={16} color="inherit" sx={sx} />
);

export default Spinner;
